export const canMakeProduct = () => () => {
    return function (nodes) {
        return [...nodes].filter(
            node => this.actions.canMakeProduct(node)
        )
    }
}

export const makeProduct = () => () => {
    return async function (nodes) {
        await this.execute(
            () => this.runParallelAction(
                () => this.actions.makeProduct(nodes),
                {action: '生成模型制品'},
            )
        )
    }
}
